import React, { Component, Fragment } from "react";
import { Alert, Button, Form, Collapse } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Glitch from 'glitch-javascript-sdk';
import Header from "../../component/layout/header";
import PageHeader from "../../component/layout/pageheader";
import Footer from "../../component/layout/footer";
import withRouter from "../../../../util/withRouter";

class NewslettersFormPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newsletter: {},
            data: {
                first_name: '',
                last_name: '',
                email: '',
                game_dev_updates: true,
                patches: true,
                event_announcements: true,
                exclusive_content_offers: true,
                community_highlights: true,
                upcoming_games_releases: true,
                strategy_gameplay_tips: true,
                industry_news_trends: true,
            },
            isLoading: false,
            errors: {},
            successMessage: '',
            showCategories: false,
            isSubscribed: false,
        };
    }

    componentDidMount() {
        const { id } = this.props.router.params;

        Glitch.api.Communities.viewNewsletter(Glitch.util.Storage.get('community_id'), id)
            .then(response => {
                this.setState({ newsletter: response.data.data });
            })
            .catch(error => {
                console.error('Error fetching newsletter:', error);
            });
    }

    handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        this.setState(prevState => ({
            data: {
                ...prevState.data,
                [name]: type === 'checkbox' ? checked : value,
            },
        }));
    };

    handleSignup = () => {
        const { data } = this.state;
        const { id } = this.props.router.params;

        this.setState({ isLoading: true, errors: {}, successMessage: '' });

        Glitch.api.Communities.registerNewsletterSubscriber(Glitch.util.Storage.get('community_id'), id, data)
            .then(() => {
                this.setState({
                    isLoading: false,
                    successMessage: "Successfully subscribed to the newsletter!",
                    isSubscribed: true,
                });
            })
            .catch(error => {
                this.setState({
                    isLoading: false,
                    errors: error.response?.data?.errors || { general: 'An error occurred during subscription.' },
                });
            });
    };

    capitalizeWords = (str) => str.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());

    render() {
        const { newsletter, data, isLoading, errors, successMessage, showCategories, isSubscribed } = this.state;

        return (
            <Fragment>
                <Header />
                <PageHeader title={"Newsletter Sign-Up"} curPage={`Sign-Up for ${newsletter.name || 'Loading...'}`} />

                <div className="container pt-5 pb-5">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2">
                            <div className="account-wrapper border rounded p-4 shadow-sm">
                                {newsletter.banner_image && (
                                    <div className="text-center mb-4">
                                        <img
                                            src={newsletter.banner_image}
                                            alt="Newsletter Banner"
                                            className="img-fluid rounded"
                                            style={{ maxHeight: '200px' }}
                                        />
                                    </div>
                                )}

                                <h3 className="title text-center">Sign-Up for {newsletter.name}</h3>
                                {newsletter.description && (
                                    <p className="text-muted text-center">{newsletter.description}</p>
                                )}
                                <hr />

                                            {/* Incentives Section */}
                            {newsletter.incentives && (
                                <div className="mb-5 p-4 bg-white border rounded shadow-sm text-black">
                                    <h4 className="fw-bold mb-3 text-black"><i className="fas fa-gift me-2 text-success"></i>Why Join?</h4>
                                    <div
                                        className="incentives-content text-start"
                                        dangerouslySetInnerHTML={{ __html: newsletter.incentives }}
                                    />
                                </div>
                            )}


                                {successMessage && <Alert variant="success">{successMessage}</Alert>}

                                {!isSubscribed && (
                                    <Form>
                                        <Form.Group controlId="firstName" className="mb-3">
                                            <Form.Label>First Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="first_name"
                                                value={data.first_name}
                                                onChange={this.handleInputChange}
                                                placeholder="Enter your first name"
                                            />
                                            {errors.first_name && (
                                                <Form.Text className="text-danger">{errors.first_name[0]}</Form.Text>
                                            )}
                                        </Form.Group>

                                        <Form.Group controlId="lastName" className="mb-3">
                                            <Form.Label>Last Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="last_name"
                                                value={data.last_name}
                                                onChange={this.handleInputChange}
                                                placeholder="Enter your last name"
                                            />
                                            {errors.last_name && (
                                                <Form.Text className="text-danger">{errors.last_name[0]}</Form.Text>
                                            )}
                                        </Form.Group>

                                        <Form.Group controlId="email" className="mb-3">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                value={data.email}
                                                onChange={this.handleInputChange}
                                                placeholder="Enter your email address"
                                            />
                                            {errors.email && (
                                                <Form.Text className="text-danger">{errors.email[0]}</Form.Text>
                                            )}
                                        </Form.Group>

                                        <Button
                                            variant="link"
                                            onClick={() => this.setState({ showCategories: !showCategories })}
                                            aria-expanded={showCategories}
                                            className="mb-3"
                                        >
                                            <i className={`fas fa-${showCategories ? 'minus' : 'plus'}-circle me-1`}></i>
                                            {showCategories ? 'Hide Categories' : 'Choose Categories'}
                                        </Button>

                                        <Collapse in={showCategories}>
                                            <div>
                                                <p>Select which categories you want to subscribe to:</p>
                                                <Form.Group controlId="categories">
                                                    {Object.keys(data).slice(3).map((category, idx) => (
                                                        <Form.Check
                                                            key={idx}
                                                            type="checkbox"
                                                            label={this.capitalizeWords(category)}
                                                            name={category}
                                                            checked={data[category]}
                                                            onChange={this.handleInputChange}
                                                            className="mb-2 d-flex align-items-center"
                                                        />
                                                    ))}
                                                </Form.Group>
                                            </div>
                                        </Collapse>

                                        {errors.general && <Alert variant="danger">{errors.general}</Alert>}

                                        <Button
                                            variant="primary"
                                            onClick={this.handleSignup}
                                            disabled={isLoading}
                                            className="w-100 mt-3"
                                        >
                                            {isLoading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Signing up...
                                                </>
                                            ) : (
                                                'Sign Up'
                                            )}
                                        </Button>
                                    </Form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </Fragment>
        );
    }
}

export default withRouter(NewslettersFormPage);
